/* eslint-disable no-underscore-dangle */
/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import Highcharts from "highcharts";

export const datazoomLogo = "../images/datazoom.svg";
export const dzLogoCircle = "../images/datazoom-logo-dp-new.svg";

export const HELP_SUPPORT = "https://datazoom.zendesk.com/hc/en-us";
export const CHECK_SUM = "check";
export const ERROR = "error";
export const MOUSE_DOWN = "mousedown";
export const TOKEN_BEARER = "Token ";
export const HOME_CHART_DIV = "currentTotalUsageGraph";

export const EMPTY_CHART = /* istanbul ignore next */ (id) => {
  Highcharts.chart(id, {
    title: {
      style: {
        color: "#ddd",
        fontSize: "16px",
      },
      text: "No data available",
      height: "200px",
      y: 180,
      floating: false,
    },
    series: [
      {
        name: " ",
        data: [],
      },
    ],
    yAxis: {
      visible: false,
    },
    xAxis: {
      visible: false,
    },
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
  });
};
export const ITEMS_PER_PAGE = 10;
export const ORDER_DESC = "DESC";
export const ORDER_ASC = "ASC";
export const VIEW_LIST = "list";
export const VIEW_GRID = "grid";
export const TIME_DELAY_FOR_MSGS = 3000;
export const ACTIVE_STATUS = 1;
export const INACTIVE_STATUS = 0;
export const ALL_STATUS = "";
export const SUB_HEADER = "sub";
export const FILTER_HEADER = "filter";
export const _ZERO = 0;
export const VISIBLE_BUTTON = "button";
export const VISIBLE_PLAYERS = "players";
export const VISIBLE_FORM = "form";
export const COLLECTOR_BLOCKED_NO = "y";
export const COLLECTOR_BLOCKED_YES = "n";
export const CONNECTOR_BLOCKED_NO = "y";
export const CONNECTOR_BLOCKED_YES = "n";
export const VISIBLE_CONNECTORS = "connectors";

export const COL_IMG_URL = "/images/collectors-player/";
export const CON_IMG_URL = "/images/connectors-player/";
export const PIPE_IMG_URL = "/images/minipipe-icon.png";

export const COL_CON_NODE_HEIGHT = 216;
export const COL_CON_NODE_DIV_HEIGHT = 200;

export const COL_CON_NODE_HEIGHT_MEDIUM = 116;
export const COL_CON_NODE_DIV_HEIGHT_MEDIUM = 100;

export const COL_CON_NODE_HEIGHT_SMALL = 66;
export const COL_CON_NODE_DIV_HEIGHT_SMALL = 50;

export const CUSTOMER_ADMIN = "CUSTOMER_ADMIN";
export const SUPER_ADMIN_ROLE = "SUPER_ADMIN";
export const USER_ROLE = "USER";
export const ADMIN_ROLE = "ADMIN";
export const COMPANY_ID = "a573aecc-03c6-472a-b2b9-4704ec9f3a92";

export const NEW_RELIC_CONNECTOR_ID = "dz-connector-newrelic";
export const AMPLITUDE_CONNECTOR_ID = "dz-connector-amplitude";
export const DATA_DOG_CONNECTOR = "dz-connector-datadog";
export const AMAZON_S3_CONNECTOR = "Amazon S3";
export const BULK_INTERVAL_MINS = "Bulk Interval Mins";
export const BULK_OUTPUT_FORMAT = "Bulk Output Format";
export const AMAZON_S3_CONNECTOR_ID = "dz-connector-s3";
export const AMAZON_S3_CONNECTOR_LABEL = "Object Name Structure";
export const CONNECTOR_REGION_LABEL = "Region";
export const NEW_RELIC_CHECKBOX_LABEL = "Use Video Data Monitoring Model";
export const AMPLITUDE_CHECKBOX_LABEL = "Redirect Standard Fields";
export const TITILE_MAX_LENGTH = 32;
export const CONNECTOR_ACTIVE = "ACTIVE";
export const CONNECTOR_INACTIVE = "INACTIVE";
export const STATUS_DISABLED = "DISABLED";
export const USER_INACTIVE = "INACTIVE";

export const ADMIN_TAB_1 = "Admin Settings / Users";
export const ADMIN_TAB_2 = "Admin Settings / Companies";
export const ADMIN_TAB_3 = "Admin Settings / Usage & Billing";
export const ADMIN_TAB_4 = "Admin Settings / Payment Details";
export const ADMIN_CURRENT_BILLING_CHART = "currentUsageGraph";

export const PLATFORM_TAB_1 = "Platform Settings / Collectors";
export const PLATFORM_TAB_2 = "Platform Settings / Connectors";
export const PLATFORM_TAB_3 = "Platform Settings / Standard Rates";
export const PLATFORM_TAB_4 = "Platform Settings / Custom Rates";

export const TAB_ONE = "1";
export const TAB_TWO = "2";
export const TAB_THREE = "3";
export const TAB_FOUR = "4";
export const TAB_FIVE = "5";
export const CALENDAR_IMG_URL = "/images/calendar_today_black.png";
export const ERROR_LOGO = "/images/DZ_wizard-sad.png";
export const ERROR_PAGE_LOGO = "/images/datazoom-logo-med-new.svg";
export const DEFAULT_FREQUENCY_LIST = [1, 5, 10, 15, 30, 60, 300];
export const MONTH_NAMES = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "June",
  "July",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];
export const MONTH_NUMBER = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
];
export const STATUS_PENDING = "PENDING";
export const STATUS_ACTIVE = "ACTIVE";
export const STATUS_ACTIVE_BUTTON = "ACTIVATE";
export const STATUS_DISABLE_BUTTON = "DISABLE";
export const BTN_APPROVE = "btnApprove";
export const PASSWORD = "password";
export const TEXT = "text";
export const NO_DATA_AVAIALBLE = "No data available";
export const TRIAL_STATUS = "TRIAL";
export const SALES_MAIL = "sales@datazoom.io";
export const CONTRACT_TYPE = "CONTRACT";
export const THEME_1 = 1;
export const THEME_2 = 2;
export const THEME_3 = 3;

export const CDN_UNSUPPORTED_CONNECTORS = [
  "Amplitude",
  "Watching That",
  "Google Analytics",
  "Google BigQuery",
];
export const TYPE_CDN = "CDN";
export const CDN_SUPPORTED_CONNECTOR_NAMES = [
  "Azure Blob Storage",
  "Amazon S3",
  "Datadog",
  "New Relic",
  "Splunk",
];
export const CDN_SUPPORTED_CONNECTORS = [
  "dz-connector-azure-blob-storage",
  "dz-connector-s3",
  "dz-connector-datadog",
  "dz-connector-newrelic",
  "dz-connector-splunk",
  "dz-connector-amplitude",
  "dz-connector-bigquery",
  "dz-connector-google-analytics",
  "dz-connector-amazon-kinesis-datastreams",
  "dz-connector-kinesis-firehose",
  "dz-connector-gcs",
  "dz-connector-mock",
  "dz-connector-s3-qa",
];

export const COLLECTOR_RELEASE = "RELEASE";
export const COLLECTOR_IN_DEVELOPMENT = "IN_DEVELOPMENT";
export const STANDARD_ACCOUNT_TYPE = "STANDARD";
export const CONTRACT_ACCOUNT_TYPE = "CONTRACT";
export const TRAIL_ACCOUNT_TYPE = "TRIAL";
export const CUSTOM_DATA_GROUP = "custom_data";
export const CUSTOM_EVENT_NAME = "custom_event";
export const CUSTOM_EVENT_LABEL = "event";
export const CUSTOM_METADATA_LABEL = "metadata";
export const CUSTOM_EVENT_METADATA = "All Events";
export const CUSTOM_METADATA_METADATA = "All Metadata";
export const SETTINGS_IMAGE = "../images/Settings_02.svg";
export const CREATE_PIPE = "/create-pipe";
export const INCORRECT_TOKEN = "Incorrect Token";
export const INVALID_USER = "Invalid User";
export const ACCESS_DENIED = "Access Denied";
export const INVALID_TOKEN = "Invalid Token";
export const USER_AUTH_SUCCESS = "Successfully authenticated user";
export const LOGOUT_SUCCESS = "Successfully logged out";
export const ENABLE_COLLECTOR = "collector_sampling";
export const ENABLE_CONNECTOR = "connector_sampling";
export const SELECTED_AD = "Event fires during Ad playback";
export const SELECTED_CONTENT = "Event fires during Content playback";
export const UNSELECTED_AD = "Event will not fire during Ad playback";
export const UNSELECTED_CONTENT = "Event will not fire during Content playback";
export const UNSUPPORTED_AD =
  "Data Point currently unavailable during Ad playback";
export const UNSUPPORTED_CONTENT =
  "Data Point currently unavailable during Content playback";
export const CREDIT_ADJUSTMENT = "creditAdjustment";
export const HYPHEN = "-";
export const TOKEN_EXPIRED = "Token Expired";
export const REFRESH_TOKEN_EXPIRED = "Invalid / Expired refresh token";
export const CONNECTOR_STATUS = ["Active", "Disabled"];
export const PROJECT_LANDINGPAGE_TITTLE = "Welcome to Datazoom Projects";
export const PROJECT_LANDINGPAGE_SUB_TITTLE =
  "Projects helps organize your Datazoom Collectors & Connectors so you can better analyze usage and costs.";
export const PROJECT_LANDINGPAGE_PARAGRAPH =
  "Create Projects to track different apps, channels, business units, customers or any other grouping that your business requires. Each Project can be linked with an unlimited number of Collectors and Connectors, allowing you to see breakdowns of your inbound and outbound data levels per Project.";
export const PROJECT_LANDINGPAGE_START = "Start getting organized today!";
export const PROJECT_LANDINGPAGE_CREATE = "Create Project";
export const DATAPIPE_ERROR = "Could not fetch data pipe.";
export const NO_ACTIVE_CUSTOMRATE = "No active custom rate card found";
export const MEDIATAILOR_ONLY = "MEDIATAILOR_ONLY";
export const MEDIATAILOR_CUSTOM = "MEDIATAILOR_CUSTOM";
export const DATAPIPE_HIDE_SUCCESS = "Data pipe is hidden from the customer";
export const DATAPIPE_UNHIDE_SUCCESS =
  "Data pipe is now visible to the customer";
export const DATAPIPE_HIDE_FAILED =
  "Data pipe is hidden from the customer is failed";
export const DATAPIPE_HIDE_FAILED_TITTLE = "Error Saving Datapipe";
export const CONNECTOR_OBFUSCATE_VALUES = [
  "HTTP Event Collector Token",
  "License Key",
  "Tracking ID",
  "API Key",
  "Access Key",
  "Secret Key",
  "Measurement ID",
  "API Secret",
  "FQDN",
  "Basic Auth Hash",
  "Password",
  "Token",
];
export const MEDIATAILOR = "MediaTailor";
export const SYNC_TOOLTIP_MSG =
  "One or more data point selections are out of sync";
export const GOOGLE_BIGQUERY = "Google BigQuery";
export const REFRESH_KEYS = "REFRESH KEYS";
export const RE_MAP_DICTIONARY_KEY = "RE-MAP DICTIONARY KEY";
export const FIELD_MAPPING = "Field Mapping";
export const DATAZOOM_KEYS_REFRESHED = "Datazoom keys refreshed";
export const DICTIONARY_VERSIONS = [
  "da5a2be6-0930-4c68-b32b-28ef5e3ccf5a",
  "368db7d9-672a-46c3-821c-9637eddcd624",
  "5ead052e-e651-48cd-8e80-a450b5e63e2a",
  "16eebabe-d9af-4cf1-8a1e-5e9e63ad33ae",
];

export const TRANSFORMATIONS_DISABLED = "Transformations disabled";
export const TRANSFORMATIONS_ENABLED = "Transformations enabled";
export const MANAGE_AUTHORSHIP_DEPRECATED_MSG =
  "Deprecated data points cannot be authored for additional collectors. Restore the data point on the Data Point Management page first.";
